/* File: assets/experience-preview-mode.js */

(() => {
  const ROOT_SEL = "[data-xp]";
  const DAY_SEL = "[data-xp-day]";
  const STEP_SEL = "[data-xp-step]";
  const MODE_BTN_SEL = "[data-xp-mode-btn]";
  const JUMP_SEL = "[data-xp-jump]";
  const DETAILS_SEL = "[data-xp-details]";
  const EXPAND_SEL = "[data-xp-expand]";
  const ROUTE_FILL_SEL = "[data-xp-route-fill]";
  const ACC_BTN_SEL = "[data-xp-acc-btn]";
  const ACC_PANEL_SEL = "[data-xp-acc-panel]";
  const CHIP_MODAL_SEL = "[data-xp-chip-modal]";
const MODAL_SEL = "[data-xp-modal]";
const MODAL_CLOSE_SEL = "[data-xp-modal-close]";
const MODAL_BODY_SEL = "[data-xp-modal-body]";
const MODAL_LINK_SEL = "[data-xp-modal-link]";
const MODAL_LINK_LABEL_SEL = "[data-xp-modal-link-label]";




  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function setMode(root, mode) {
    root.dataset.mode = mode;

    // Toggle button active states + aria-pressed
    const btns = root.querySelectorAll(MODE_BTN_SEL);
    btns.forEach((b) => {
      const isActive = b.dataset.mode === mode;
      b.classList.toggle("is-active", isActive);
      b.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    // In detailed mode, show details; in overview, hide details.
    const details = root.querySelectorAll(DETAILS_SEL);
    details.forEach((d) => {
      // CSS handles display by mode; keep aria semantics consistent for screen readers
      const isDetailed = mode === "detailed";
      d.setAttribute("aria-hidden", isDetailed ? "false" : "true");
    });
  }

  function smoothScrollTo(el) {
    try {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } catch (e) {
      // fallback
      const y = el.getBoundingClientRect().top + window.pageYOffset - 16;
      window.scrollTo(0, y);
    }
  }

  function initOne(root) {
    const days = Array.from(root.querySelectorAll(DAY_SEL));
    const steps = Array.from(root.querySelectorAll(STEP_SEL));
    const routeFill = root.querySelector(ROUTE_FILL_SEL);

    if (!days.length || !steps.length) return;

    // Default mode
    setMode(root, "overview");

    // Mode buttons
    root.querySelectorAll(MODE_BTN_SEL).forEach((btn) => {
      btn.addEventListener("click", () => setMode(root, btn.dataset.mode));
    });

    // Jump buttons
    root.querySelectorAll(JUMP_SEL).forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.dataset.xpTarget;
        const target = document.getElementById(id);
        if (!target) return;
        smoothScrollTo(target);
      });
    });

    // Reveal on enter
    const revealObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-in");
        });
      },
      { threshold: 0.12 }
    );

    days.forEach((d) => revealObs.observe(d));

    // Scroll spy (active step)
    let activeIndex = 0;

function setActive(idx) {
  activeIndex = clamp(idx, 0, steps.length - 1);

  steps.forEach((s, i) => s.classList.toggle("is-active", i === activeIndex));
  days.forEach((d, i) => d.classList.toggle("is-active", i === activeIndex));

  // Route fill: fill to the active step (0% at first, 100% at last)
  if (routeFill && steps.length > 1) {
    const pct = (activeIndex / (steps.length - 1)) * 100;
    routeFill.style.height = `${pct}%`;
  }
}



    // A more stable spy: treat the "active" day as the one closest to top third of viewport.
    function computeActiveIndex() {
      const topBias = window.innerHeight * 0.28;
      let bestIdx = 0;
      let bestDist = Infinity;

      for (let i = 0; i < days.length; i++) {
        const r = days[i].getBoundingClientRect();
        const dist = Math.abs(r.top - topBias);
        if (dist < bestDist) {
          bestDist = dist;
          bestIdx = i;
        }
      }
      setActive(bestIdx);
    }

    // Throttle scroll handler with rAF
    let ticking = false;
    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          computeActiveIndex();
          ticking = false;
        });
      },
      { passive: true }
    );

    // Initial active
    computeActiveIndex();

    // Mobile expand/collapse per card (optional)
    root.querySelectorAll(EXPAND_SEL).forEach((btn) => {
      btn.addEventListener("click", () => {
        const expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", expanded ? "false" : "true");

        const controls = btn.getAttribute("aria-controls");
        const panel = controls ? document.getElementById(controls) : null;
        if (!panel) return;

        // Only meaningful in detailed mode; if user expands in overview, flip to detailed automatically.
        if (root.dataset.mode !== "detailed") {
          setMode(root, "detailed");
        }

        panel.style.display = expanded ? "none" : "block";
      });
    });

    // In detailed mode, ensure panels are visible; in overview, collapse panels (mobile only)
    const mq = window.matchMedia("(max-width: 990px)");

    function syncPanelsForMode() {
      const isMobile = mq.matches;
      const isDetailed = root.dataset.mode === "detailed";

      root.querySelectorAll(EXPAND_SEL).forEach((btn) => {
        const controls = btn.getAttribute("aria-controls");
        const panel = controls ? document.getElementById(controls) : null;
        if (!panel) return;

        if (!isMobile) {
          // Desktop: CSS controls visibility; reset inline styles
          panel.style.display = "";
          btn.setAttribute("aria-expanded", "true");
          return;
        }

        // Mobile:
        // - Overview: hide panels
        // - Detailed: show panels (unless user toggled)
        if (!isDetailed) {
          panel.style.display = "none";
          btn.setAttribute("aria-expanded", "false");
        } else {
          // If user hasn't interacted yet, show by default
          const hasInline = panel.style.display === "none" || panel.style.display === "block";
          if (!hasInline) {
            panel.style.display = "block";
            btn.setAttribute("aria-expanded", "true");
          }
        }
      });
    }

    // What-if accordion
const accBtns = Array.from(root.querySelectorAll(ACC_BTN_SEL));
if (accBtns.length) {
  accBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const expanded = btn.getAttribute("aria-expanded") === "true";
      const id = btn.getAttribute("aria-controls");
      const panel = id ? document.getElementById(id) : null;

      // close all others for a cleaner premium feel (single-open accordion)
      accBtns.forEach((b) => {
        if (b !== btn) b.setAttribute("aria-expanded", "false");
        const pid = b.getAttribute("aria-controls");
        const p = pid ? document.getElementById(pid) : null;
        if (p && p !== panel) p.hidden = true;
      });

      // toggle clicked
      btn.setAttribute("aria-expanded", expanded ? "false" : "true");
      if (panel) panel.hidden = !(!expanded);
    });
  });
}

// Chip mini modal
const modal = root.querySelector(MODAL_SEL);
if (modal) {
  const titleEl = modal.querySelector(`#xp-modal-title-${root.dataset.xpId}`);
  const bodyEl = modal.querySelector(MODAL_BODY_SEL);
  const linkEl = modal.querySelector(MODAL_LINK_SEL);
  const linkLabelEl = modal.querySelector(MODAL_LINK_LABEL_SEL);

  let lastFocus = null;

  function openModal({ title, body, url, label }) {
    lastFocus = document.activeElement;

    if (titleEl) titleEl.textContent = title || "Details";
    if (bodyEl) bodyEl.textContent = body || "";

    if (linkEl) {
      if (url) {
        linkEl.href = url;
        linkEl.hidden = false;
        if (linkLabelEl) linkLabelEl.textContent = label || "View details";
      } else {
        linkEl.hidden = true;
      }
    }

    modal.hidden = false;
    // allow CSS transition
    requestAnimationFrame(() => modal.classList.add("is-open"));

    // lock scroll
    document.documentElement.style.overflow = "hidden";

    // focus close button for accessibility
    const closeBtn = modal.querySelector(MODAL_CLOSE_SEL);
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove("is-open");
    document.documentElement.style.overflow = "";

    // wait for transition then hide
    window.setTimeout(() => {
      modal.hidden = true;
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    }, 180);
  }

  // Open on chip click (event delegation)
  root.addEventListener("click", (e) => {
    const btn = e.target.closest(CHIP_MODAL_SEL);
    if (!btn) return;

    const title = btn.dataset.modalTitle || "";
    const body = btn.dataset.modalBody || "";
    const url = btn.dataset.modalUrl || "";
    const label = btn.dataset.modalLabel || "";

    openModal({ title, body, url, label });
  });

  // Close handlers
  modal.querySelectorAll(MODAL_CLOSE_SEL).forEach((el) => {
    el.addEventListener("click", closeModal);
  });

  // Close on ESC
  document.addEventListener("keydown", (e) => {
    if (modal.hidden) return;
    if (e.key === "Escape") closeModal();
  });
}



    // Watch mode changes
    root.querySelectorAll(MODE_BTN_SEL).forEach((btn) => {
      btn.addEventListener("click", () => syncPanelsForMode());
    });

    // Watch breakpoint changes
    mq.addEventListener("change", syncPanelsForMode);
    syncPanelsForMode();
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
